import React, { FC } from 'react'
import { css } from '@emotion/react'
import { breakpoints } from 'front-end/src/components/chakraThemeExtension'
import { Box } from 'front-end/src/components'
import { BoxProps } from '@chakra-ui/react'

interface Props {
  className?: string
  columns: Array<string>
  flexWrap?: string
  columnGap?: string
  rowGap?: string
  padding?: string
  marginOutside?: boolean
  dataTest?: string
}

export const FlexBoxGrid: FC<Props & BoxProps> = (props) => {
  const ZERO = '0px'
  const {
    className,
    columns,
    flexWrap,
    columnGap,
    rowGap,
    padding,
    marginOutside,
    children,
    dataTest,
    ...rest
  } = props

  const styles = css`
    padding: ${padding ?? '0px'};

    .wrapper {
      display: flex;
      flex-wrap: ${flexWrap ?? 'wrap'};
      padding: ${marginOutside &&
      `calc(0.5 * ${rowGap ?? ZERO})
        calc(0.5 * ${columnGap ?? ZERO});`};
    }

    .wrapper > * {
      display: flex;
      flex: 1 1 0;
      min-width: ${columns[0]};
      padding: calc(0.5 * ${rowGap ?? ZERO}) calc(0.5 * ${columnGap ?? ZERO});
    }

    .wrapper > br {
      content: ' ';
      line-height: 0px;
      visibility: hidden;
      pointer-events: none;
      padding: 0 calc(0.5 * ${columnGap ?? ZERO});
    }

    @media (min-width: ${breakpoints.sm}) {
      .wrapper > * {
        min-width: ${columns[1]};
      }
    }

    @media (min-width: ${breakpoints.md}) {
      .wrapper > * {
        min-width: ${columns[2]};
      }
    }

    @media (min-width: ${breakpoints.lg}) {
      .wrapper > * {
        min-width: ${columns[3]};
      }
    }
  `

  return (
    <Box className={className} css={styles} data-test={dataTest} {...rest}>
      <div className="wrapper">
        {children}
        <br />
        <br />
        <br />
      </div>
    </Box>
  )
}
